import React from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import "./SchoolSummary.css";

const schoolSummaryReduxSchoolsIdList = "schoolSummarySchoolsIdList";

const SchoolSummary = (props) => {
  const school = props.school;
  var thumbnail = null;

  const schools = props.schoolSummarySchoolsIdList;
  const clickedSchoolId = school.id;

  var schoolName = null;
  var schoolLogo = null;

  const handleClick = () => {
    if (schools) {
      const schoolId = clickedSchoolId;
      schoolName = schools[schoolId].name;
      schoolLogo = schools[schoolId].logo;

      props.selectSchool(schoolId, schoolName, schoolLogo);
    }
  };

  if (school.logo) {
    thumbnail = <img src={school.logo} alt="School Logo" />;
  } else {
    thumbnail = (
      <img
        src={require("../../images/universityIcon.svg").default}
        alt="University Building"
      />
    );
  }

  return (
    <div className="SchoolRow" onClick={handleClick}>
      <div className="SchoolThumbnailContainer">{thumbnail}</div>
      <div className="SchoolNameContainer">
        <h3>{school.name}</h3>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    schoolSummarySchoolsIdList: state.firestore.data.schoolSummarySchoolsIdList,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "schools",
      storeAs: schoolSummaryReduxSchoolsIdList,
    },
  ])
)(SchoolSummary);
